import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImportarDadosBancariosService {

  public ImportacaoDadosBancariosVO : any ;

  constructor( private readonly http: HttpClient ) { }

  public verificarOcorrencia( idEmpresa , file ){

    return this.http.post (`/apiconnect/importation/validate-imports/companies?idEmpresa=${idEmpresa}` , file).pipe(
      tap( resposta => {
        this.ImportacaoDadosBancariosVO = resposta;
      }));
  }

  public salvarImportacao( idEmpresa, obj ){
    return this.http.post (`/apiconnect/orders/import/bank-details?idEmpresa=${idEmpresa}` , obj);
  }

  public getArquivo (idEmpresa , tipoArquivo) {
    return this.http.get( `/apiconnect/importation/report/bank-layout/${idEmpresa}/companies?tipoArquivo=${tipoArquivo}` , {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public getHistorico (idEmpresa , url) {
    return this.http.get( `/apiconnect/orders/import/last-bank-data/${idEmpresa}/companies${url}` );
  }
}
